import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import decimalComponent from "@/components/child/form/decimal.vue";
import decimalComSinalCustomComponent from "@/components/child/form/decimalComSinalCustom.vue";
import decimalComSufixoNullableComponent from "@/components/child/form/decimalComSufixoNullable";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import moedaComponent from "@/components/child/form/moeda.vue";
import { GridColumn, GridColumnType, GridColumnWithoutSort } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import PaginationModel from "@/models/paginationModel";
import ProdutoLogFinanceiroModel from "@/models/produtoLogFinanceiroModel";
import ProdutoLogFinanceiroService from "@/services/produto/produtoLogFinanceiroService";

import ListComponentBase from "../listComponentBase";

import "../crud.scss";

@Component({
    components: {
        dateTimePickerComponent,
        fieldsetComponent,
        moedaComponent,
        decimalComponent,
        decimalComSinalCustomComponent,
        decimalComSufixoNullableComponent,
    },
})
export default class ProdutoLogFinanceiroListComponent extends ListComponentBase<ProdutoLogFinanceiroModel> {
    private produtoLogFinanceiroService = new ProdutoLogFinanceiroService();
    private model = new ProdutoLogFinanceiroModel();

    dataUltimaAlteracao = null;
    usuarioUltimaAlteracao = "";

    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumnWithoutSort("dataCriacao", "Data da atualização", GridColumnType.DateTime),
            new GridColumnWithoutSort("rotinaAlteracao", "Rotina", GridColumnType.String),
            new GridColumnWithoutSort("usuarioCriacaoDescricao", "Usuário", GridColumnType.String),
            new GridColumn("valorCusto", "Valor Custo", GridColumnType.Money, false, false, "", "", false, false, 4),
            new GridColumn(
                "custoReferencia",
                "Custo Referência",
                GridColumnType.Money,
                false,
                false,
                "",
                "",
                false,
                false,
                4,
            ),
            new GridColumn("custoMedio", "Custo Médio", GridColumnType.Money, false, false, "", "", false, false, 4),
            new GridColumn("markup", "Markup", GridColumnType.Percent),
            new GridColumn("valorVenda", "Valor Venda", GridColumnType.Money, false, false, "", "", false, false, 4),
        ];
    }

    private beforeMount() {
        this.setProps(new ProdutoLogFinanceiroService(), "", "datacriacao");

        this.pageSize = 10;
        this.gridSortOrder = "desc";
    }

    public async loadByProduto(model: ProdutoLogFinanceiroModel) {
        this.model.updateFrom(model);

        await this.load();
    }

    public async loadMethod() {
        if (!this.model.produtoId) {
            return new PaginationModel<ProdutoLogFinanceiroModel>();
        }

        const data = await this.produtoLogFinanceiroService
            .listByProduto(
                this.gridFilterKey,
                this.gridSortKey,
                this.gridSortOrder,
                this.pags ? 1 : this.pageIndex,
                10,
                this.model.produtoId,
            )
            .withLoading()
            .resolveWithJSON<PaginationModel<ProdutoLogFinanceiroModel>>();

        if (data.total == 0) {
            await this.$showError(this.$t("__.ts.logAlt"), this.$t("__.ts.naoHouveAltRegis"));
        } else {
            return data;
        }
    }

    private close() {
        this.$emit("close");
    }
}
